<template>
  <component
    :is="currentIconComponentName"
    class="base-icon"
    :key="key"
    :icon="icon"
    :color="color"
    :width="width"
    :height="height"
  />
</template>

<script>
export default {
  name: 'BaseIcon',
  components: {
    IconsButton: () => import('components/icons/button/IconsButton'),
    IconsPages: () => import('components/icons/pages/IconsPages'),
    IconsInterface: () => import('components/icons/interface/IconsInterface'),
    IconsPush: () => import('components/icons/push/IconsPush'),
    IconsCommon: () => import('components/icons/IconsCommon'),
    IconsChat: () => import('components/icons/IconsChat'),
    IconsLoader: () => import('components/icons/IconsLoader'),
    IconsMark: () => import ('components/icons/IconsMark'),
    IconsFile: () => import ('components/icons/IconsFile'),
  },
  props: {
    icon: String,
    color: String,
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      key: 0,
    }
  },
  watch: {
    $props: {
      deep: true,
      handler() {
        this.key++
      },
    },
  },
  computed: {
    iconsList() {
      return [
        {
          if: this.icon.includes('button-'),
          name: 'IconsButton',
        },
        {
          if: this.icon.includes('pages-'),
          name: 'IconsPages',
        },
        {
          if: this.icon.includes('interface-') && !this.icon.includes('pages-settings-interface'),
          name: 'IconsInterface',
        },
        {
          if: this.icon.includes('push-'),
          name: 'IconsPush',
        },
        {
          if: this.icon.includes('common-'),
          name: 'IconsCommon',
        },
        {
          if: this.icon.includes('chat-'),
          name: 'IconsChat',
        },
        {
          if: this.icon.includes('loader-'),
          name: 'IconsLoader',
        },
        {
          if: this.icon.includes('mark-'),
          name: 'IconsMark',
        },
        {
          if: this.icon.includes('file-'),
          name: 'IconsFile',
        },
      ]
    },
    currentIconComponentName() {
      return this.icon ? this.iconsList.find((i) => i.if === true).name : null
    },
  },
}
</script>

<style lang="scss" scoped>
// .base-icon {
//   height: max-content;
//   line-height: 0;
// }
</style>
